import React from 'react';

const ChevronDownIcon: React.FC<{ className?: string, onClick?: () => void }> = ({ className, onClick }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className || "w-6 h-6"} onClick={onClick}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
  </svg>
);

export default ChevronDownIcon;
